import { Component, OnInit } from '@angular/core';
import { CommunicationService } from 'src/app/services/Communication/communication.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-documents-uploading',
  templateUrl: './documents-uploading.component.html',
  styleUrls: ['./documents-uploading.component.css']
})
export class DocumentsUploadingComponent implements OnInit {

  DocumentUploadList = [];
  SubmittedSearch = false;
  Submitted = false;
  UploadMsg = '';
  SelectedFileForUpload: any;
  DocumentList = [];
  DocumentTypeList = [];
  DocumentListSearch = [];
  ClassList = [];
  SubjectList = [];
  StaffList = [];
  SubjectListSearch = [];
  StaffListSearch = [];

  constructor(private communicationservice: CommunicationService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  SearchModel = {
    DocumentTypeID: 0,
    ClassID: 0,
    DocumentID: 0,
    SubjectID: 0,
    StaffID: 0,
  }

  ClearSearch() {
    this.DocumentUploadList = [];
    this.SubmittedSearch = false;
    this.SearchModel.ClassID = 0;
    this.SearchModel.DocumentID = 0;
    this.SearchModel.SubjectID = 0;
    this.SearchModel.StaffID = 0;
    this.SearchModel.DocumentTypeID = 0;
  };



  GetAllDocumentsUploading() {
    this.spinnerService.show();
    this.communicationservice.GetAllDocumentsUploading(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
      this.DocumentUploadList = data.DocumentUploadList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
    });
  };

  SaveUpdateModel = {
    DocumentUploadID: 0,
    DocumentTypeID: 0,
    ClassID: 0,
    DocumentID: 0,
    SubjectID: 0,
    StaffID: 0,
    IsPublic: false,
    Description: '',
    FilePath: '',
    DocumentName: '',
  }

  ClearSave() {
    this.Submitted = false;
    this.SaveUpdateModel.DocumentUploadID = 0;
    this.SaveUpdateModel.ClassID = 0;
    this.SaveUpdateModel.DocumentID = 0;
    this.SaveUpdateModel.SubjectID = 0;
    this.SaveUpdateModel.StaffID = 0;
    this.SaveUpdateModel.DocumentTypeID = 0;
    this.SaveUpdateModel.Description = '';
    this.SaveUpdateModel.IsPublic = false;
    this.SaveUpdateModel.FilePath = '';
    this.UploadMsg = '';
  };

  Edit(item) {
    this.SaveUpdateModel.DocumentTypeID = item.DocumentTypeID;
    this.GetAllCommDocument();
    this.SaveUpdateModel.DocumentID = item.DocumentID;
    this.SaveUpdateModel.DocumentUploadID = item.DocumentUploadID;
    this.SaveUpdateModel.Description = item.Description;
    this.SaveUpdateModel.FilePath = item.FilePath;
    this.SaveUpdateModel.IsPublic = item.IsPublic;
    if (item.DocumentTypeID == 2) {
      this.SaveUpdateModel.ClassID = item.ClassID;
      this.GetAllSubject();
      setTimeout(() => {
        this.SaveUpdateModel.SubjectID = item.SubjectID;
        this.GetAllTeacher();
      }, 500);

      setTimeout(() => {
        this.SaveUpdateModel.StaffID = item.StaffID;
      }, 500);
    }


  };
  selectFileforUpload(file) {
    this.SelectedFileForUpload = file[0];
  };

  ValidityState() {
    return this.SaveUpdateModel.ClassID == 0 || this.SaveUpdateModel.DocumentTypeID == 0 || this.SaveUpdateModel.DocumentID == 0;
  }

  ValidityState1() {
    return this.SaveUpdateModel.DocumentTypeID == 0 || this.SaveUpdateModel.DocumentID == 0;
  }

  SaveDocumentsUploading(valid) {
    this.UploadMsg = '';
    this.Submitted = true;
    if ((valid && this.SaveUpdateModel.DocumentTypeID == 1 && !this.ValidityState1()) || valid && this.SaveUpdateModel.DocumentTypeID == 2 && !this.ValidityState()) {
      if (this.SaveUpdateModel.FilePath == '' && this.SelectedFileForUpload == undefined) {
        this.UploadMsg = 'Please Select Document';
        return;
      }
      for (var j = 0; j < this.DocumentList.length; j++) {
        if (this.DocumentList[j].ItemId == this.SaveUpdateModel.DocumentID) {
          this.SaveUpdateModel.DocumentName = this.DocumentList[j].ItemName;
          break;
        }
      }
      this.spinnerService.show();
      this.communicationservice.SaveDocumentsUploading(JSON.stringify(this.SaveUpdateModel), this.SelectedFileForUpload).subscribe((data: any) => {
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);
        if (this.SaveUpdateModel.DocumentUploadID == 0 && data.webResponse.Status) {
          this.ClearSave();
          this.GetAllDocumentsUploading();
        }
        else if (data.webResponse.Status) {
          this.GetAllDocumentsUploading();
        }

      });
    }
  };



  // Init and Lookup

  ngOnInit() {
    this.GetAllDocumentType();
    this.GetAllClass();
    this.GetAllDocumentsUploading();
  }

  GetAllDocumentType() {
    this.spinnerService.show();
    this.lookupservice.GetLookupsList('COMMDocumentType', '').subscribe((data: any) => {
      this.DocumentTypeList = data.LookupItems;
      this.spinnerService.hide();
    });
  };

  GetAllCommDocument() {
    this.spinnerService.show();
    var itemBo = {
      'ItemId': this.SaveUpdateModel.DocumentTypeID,

    };
    this.lookupservice.GetLookupsList('COMMDocument', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.DocumentList = data.LookupItems;
      this.spinnerService.hide();
    });
  };

  GetAllCommDocumentSearch() {
    this.spinnerService.show();
    var itemBo = {
      'ItemId': this.SearchModel.DocumentTypeID,

    };
    this.lookupservice.GetLookupsList('COMMDocument', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.DocumentListSearch = data.LookupItems;
      this.spinnerService.hide();
    });
  };
  
  GetAllClass() {
    this.spinnerService.show();
    this.lookupservice.GetLookupsList('Class', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
      this.spinnerService.hide();
    });
  };

  GetAllSubject() {
    this.spinnerService.show();
    var itemBo = {
      'ItemId': this.SaveUpdateModel.ClassID,

    };
    this.lookupservice.GetLookupsList('AdminHomeworkSubject', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.SubjectList = data.LookupItems;
      this.spinnerService.hide();
    });
  };

  GetAllTeacher() {
    this.spinnerService.show();
    var itemBo = {
      'ItemId': this.SaveUpdateModel.ClassID,
      'ItemId1': this.SaveUpdateModel.SubjectID,

    };
    this.lookupservice.GetLookupsList('CommClassSubjectTeacher', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.StaffList = data.LookupItems;
      this.spinnerService.hide();
    });
  };

  GetAllSubjectSearch() {
    this.spinnerService.show();
    var itemBo = {
      'ItemId': this.SearchModel.ClassID,

    };
    this.lookupservice.GetLookupsList('AdminHomeworkSubject', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.SubjectListSearch = data.LookupItems;
      this.spinnerService.hide();
    });
  };

  GetAllTeacherSearch() {
    this.spinnerService.show();
    this.SearchModel.StaffID = 0;
    var itemBo = {
      'ItemId': this.SearchModel.ClassID,
      'ItemId1': this.SearchModel.SubjectID,

    };
    this.lookupservice.GetLookupsList('CommClassSubjectTeacher', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.StaffListSearch = data.LookupItems;
      this.spinnerService.hide();
    });
  };

}
